export enum FinancingCertificateStatus {
  FINANCING_CERTIFICATE_STATUS_UNKNOWN = 'unknown',
  FINANCING_CERTIFICATE_STATUS_TO_VERIFY = 'toVerify',
  FINANCING_CERTIFICATE_STATUS_VALID = 'valid',
  FINANCING_CERTIFICATE_STATUS_EXPIRED = 'expired',
}
